import {memo} from 'react';
import {Avatar} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {regular} from "@fortawesome/fontawesome-svg-core/import.macro";
import {size} from "@material-tailwind/react/types/components/avatar";

interface BrokerAvatarProps {
    image: string,
    size?: size
    className?: string,
    imageClasses?: string
}

const BrokerAvatar = ({image, className, imageClasses, size = "md"}: BrokerAvatarProps) => {
    return image ? <Avatar size={size}
                           className={`border border-blue-gray-50 dark:border-blue-gray-500 bg-blue-gray-50/50 dark:bg-blue-gray-700 object-contain mr-2 ${className ?? 'h-8 w-8'}`}
                           src={`${window.location.origin}/images/users/${image}`}/>
        : <div className="inline-flex mr-2">
            <span
                className={`border flex items-center justify-center border-blue-gray-50 dark:border-blue-gray-500 bg-blue-gray-50/50 dark:bg-blue-gray-700 p-2 rounded-full ${className ?? 'h-8 w-8'}`}><FontAwesomeIcon
                className={`text-gray-400 dark:text-gray-600 ${imageClasses ?? 'h-5 w-5'}`} icon={regular("user")}/></span>
        </div>;
}

export default memo(BrokerAvatar);
